const CopyClipboard = ($) => {
  const btn = $(".js-copy-clipboard");

  btn.on('click', async (e) => {
    const currentBtn = $(e.currentTarget);
    const toolTipTextInitial = $('.tooltip', currentBtn).text();
    console.log(toolTipTextInitial);
    try {
      await navigator.clipboard.writeText(currentBtn.data('url'));
      $('.tooltip', currentBtn).text("Texte copié !");

      setTimeout(() => {
        $('.tooltip', currentBtn).text(toolTipTextInitial);
        currentBtn.blur();
      }, "2000")
    } catch (err) {
      $('.tooltip', currentBtn).text("Une erreur est survenue");

      setTimeout(() => {
        $('.tooltip', currentBtn).text(toolTipTextInitial);
        currentBtn.blur();
      }, "2000")
    }
  })
};


export default CopyClipboard;
